import { render, staticRenderFns } from "./ChooseCountry.vue?vue&type=template&id=0ff09a8a&scoped=true&"
import script from "./ChooseCountry.vue?vue&type=script&lang=ts&"
export * from "./ChooseCountry.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseCountry.vue?vue&type=style&index=0&id=0ff09a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff09a8a",
  null
  
)

export default component.exports